<template>
  <div class="tapioka">
        <h2 class="title is-4"  style="font-weight:bold;">タピオカ</h2>
        <div class="columns">
          <div class="column">
            <p class="title is-5">①単位</p>
            <div class="field is-grouped is-grouped-centered">
              <b-select v-model="tapioka" placeholder="Select a character">
                <option :value="tapioka_kal">カロリー</option>
                <option :value="tapioka_gram">重さ</option>
              </b-select>
            </div>
          </div>
          <div class="column is-1">
            <i class="fas fa-times"></i>
          </div>
          <div class="column">
            <p class="title is-5">②比較するもの</p>
            <div v-if="tapioka.category == '比較対象'">
              <div class="field is-grouped is-grouped-centered">
                  <b-select v-model="target" placeholder="Select a character">
                  </b-select>
              </div>
            </div>
            <div v-if="tapioka.category == '重さ'">
              <div class="field is-grouped is-grouped-centered">
                  <b-select v-model="target" placeholder="Select a character">
                    <option v-for="gram in grams" :key="gram.grams" :value="gram">
                      <span>{{gram.name}}</span>
                    </option>
                  </b-select>
              </div>
            </div>
            <div v-if="tapioka.category == 'カロリー'">
              <div class="field is-grouped is-grouped-centered">
                  <b-select v-model="target" placeholder="Select a character">
                    <option v-for="kal in kals" :key="kal.kals" :value="kal">
                      <span>{{kal.name}}</span>
                    </option>
                  </b-select>
              </div>
            </div>
          </div>
          <div class="column is-1">
            <i class="fas fa-times"></i>
          </div>
          <div class="column">
            <p class="title is-5">③数字</p>
            <div class="field is-grouped is-grouped-centered">
              <b-input style="width:70px; text-align:center;" v-model="target.number"></b-input>
              <span style="padding-top:10px;">{{target.unit}}</span>
            </div>
          </div>
        </div>
    <div class="result">
      <b-button @click="cal" class="is-info">結果を見る</b-button>
      <div v-if="err" style="color:red;">未選択の項目があります</div>
      <p v-if="calAnswer" class="choice_result">{{target.name}} × {{tapioka.name1}}</p>
        <div v-if="calAnswer" class="result_card">
            <p>{{target.name}} <span style="font-size:1.1em; font-weight:bold;">{{target.number}}</span> {{target.unit}} は、{{tapioka.name1}} <span style="font-size:1.2em; font-weight:bold;">{{answer1}}</span> {{tapioka.unit1}}、{{tapioka.name2}} <span style="font-size:1.2em; font-weight:bold;">{{answer2}}</span> {{tapioka.unit2}} 相当の{{target.category}}です </p>
            <p>ちなみに、{{tapioka.name2}}1杯で、{{target.name}} <span style="font-size:1.2em; font-weight:bold;">{{answer3}}</span> {{target.unit}}分です。</p>
        </div>
        <p v-if="calAnswer" class="subtitle is-7">(タピオカ一粒1グラム、タピオカミルクティー500グラム、{{target.name}}{{target.category_value}}{{target.category_unit}}で計算)</p>
        <p v-if="calAnswer" class="share_button"><b-button @click="share" type="is-info" icon-left="twitter" outlined>シェア</b-button></p>
        <p v-if="calAnswer" class="title is-6">結果をシェアしよう！</p>
    </div>

    <div class="explain">
      <hr>
      <h2>タピオカの重量とカロリーについて</h2>
      <p>タピオカは乾燥状態だと一粒0.7グラムで、茹でた後だと1グラムになります。</p>
      <p>カロリーは、タピオカ自体が100グラムで346kcal、ミルクティー500mlで700kcalになります。</p>
      <p>*数値はあくまで目安でお考えください。</p>
      <h2>登録データ</h2>
      <span v-for="gramData in grams" :key="gramData.grams">
        <b-tag>{{ gramData.name }}</b-tag>
      </span>
      <span v-for="kalData in kals" :key="kalData.grams">
        <b-tag>{{ kalData.name }}</b-tag>
      </span>
    </div>
    <p class="auther">made by <a href="https://ameneko.com/">雨のネコ社</a></p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'home',
  mounted(){
    const title = "タピオカ換算｜色々計算サイト"
    const description = "タピオカのカロリー計算や換算ができます"
    document.title = title
    document.querySelector("meta[property='og:title']")
    　.setAttribute('content', title)
    document.querySelector("meta[name='description']")
    　.setAttribute('content', description)
    document.querySelector("meta[property='og:description']")
    　.setAttribute('content', description)
  },
  data() {
    return {
      calAnswer: false,
      err: null,
      shareWord: "",
      target: {category:"単位"},
      tapioka: {category:"比較対象"},
      //gram
      tapioka_gram: {name1:"タピオカ",name2:"タピオカミルクティー", unit1:"粒",unit2:"杯",category:"重さ", value1:1, value2:500, math:1},
          grams:{
            //あ
                犬:{name:"犬", number:'1', unit:"匹", category:"重さ", value:5000, category_value:5, category_unit:"キロ" },
            //か
                こち亀全巻:{name:"こち亀全巻", number:'1', unit:"つ", category:"重さ", value:30000, category_value:30, category_unit:"キロ"},
            //さ
            //た
                体重:{name:"体重", number:'', unit:"キロ", category:"重さ", value:1000, category_value:"", category_unit:""},
                ドラえもん:{name:"ドラえもん",number:'1', unit:"人", category:"重さ", value:129300, category_value:129.3, category_unit:"キロ"},
            //な
            //は
            //ま
            //や
            //ら
                りんご:{name:"りんご",number:'1', unit:"個", category:"重さ", value:250, category_value:250, category_unit:"グラム" },
            //わ

            },
            //kal
        tapioka_kal: {name1:"タピオカ", name2:"タピオカミルクティー", unit1:"粒",unit2:"杯",category:"カロリー", value1:3.46, value2:700,},
        kals:{
            //あ
                アイスクリーム: {name:"アイスクリーム", unit:"個", category:"カロリー", number:'1', value:244, category_value:244, category_unit:"キロカロリー"},
                ウォーキング: {name:"ウォーキング", unit:"時間", category:"カロリー消費", number:'1', value:189},
                おにぎり: {name:"おにぎり", unit:"個", category:"カロリー", number:'1', value:215, category_value:215, category_unit:"キロカロリー"},
            //か
                カップラーメン: {name:"カップラーメン", unit:"個", category:"カロリー", number:'1', value:353, category_value:353, category_unit:"キロカロリー"},
                ご飯: {name:"ご飯", unit:"杯", category:"カロリー", number:'1', value:235, category_value:235, category_unit:"キロカロリー"},
                コーヒーブラック: {name:"コーヒー(ブラック)", unit:"杯", category:"カロリー", number:'1', value:8, category_value:8, category_unit:"キロカロリー"},
            //さ
            //た
            //な
            //は
                ハンバーガー: {name:"ハンバーガー", unit:"個", category:"カロリー", number:'1', value:256, category_value:256, category_unit:"キロカロリー"},
                ビール: {name:"ビール", unit:"杯", category:"カロリー", number:'1', value:150, category_value:150, category_unit:"キロカロリー"},
                歩数: {name:"歩数", unit:"歩", category:"カロリー消費", number:'1', value:0.06, category_value:0.06, category_unit:"キロカロリー"},
                ポテト: {name:"ポテト(Mサイズ)", unit:"個", category:"カロリー", number:'1', value:410, category_value:410, category_unit:"キロカロリー"},
                ポテトチップ塩: {name:"ポテチ(塩)", unit:"袋", category:"カロリー", number:'1', value:336, category_value:336, category_unit:"キロカロリー"},
                ポテトチップコンソメ: {name:"ポテチ(コンソメ)", unit:"袋", category:"カロリー", number:'1', value:334,category_value:334, category_unit:"キロカロリー"},
            //ま
                マグロ刺身: {name:"マグロ(刺身)", unit:"切れ", category:"カロリー消費", number:'1', value:25,category_value:25, category_unit:"キロカロリー"},
            //や
                雪見だいふく: {name:"雪見だいふく", unit:"個", category:"カロリー消費", number:'2', value:82,category_value:82, category_unit:"キロカロリー"},
            //ら   
                ラーメン醤油: {name:"醤油ラーメン", unit:"杯", category:"カロリー", number:'1', value:416,category_value:416, category_unit:"キロカロリー"},
                ラーメンとんこつ: {name:"とんこつラーメン", unit:"杯", category:"カロリー", number:'1', value:508, category_value:508, category_unit:"キロカロリー"},
                ラーメン二郎: {name:"ラーメン二郎", unit:"杯", category:"カロリー", number:'1', value:1371, category_value:1371, category_unit:"キロカロリー"},
                ランニング: {name:"ランニング", unit:"時間", category:"カロリー消費", number:'1', value:567, category_value:567, category_unit:"キロカロリー"},
            //わ
            },
        }
  },
  computed:{
    answer1(){
      return ((this.target.number * this.target.value) / this.tapioka.value1).toFixed(0)
    },
    answer2(){
      var cal = (this.target.number * this.target.value) / this.tapioka.value2
      var calResult = Math.round(cal * 100) / 100
      return calResult
    },
    answer3(){
      return (this.tapioka.value2 / this.target.value).toFixed(1)
    },
  },
  methods:{
    cal(){
      if(this.target.category !="単位" && this.tapioka.category !="比較対象" && this.target.number != '' ){
        this.calAnswer = true
        this.err = false
        this.shareWord = "ちなみに、" + this.tapioka.name2 + "1杯で、" + this.target.name + this.answer3 + this.target.unit + "分です。"
      }else{
        this.err = true
      }
    },
    share(){
      
      var shareURL = 'https://twitter.com/intent/tweet?text='
       +this.target.name + this.target.number + this.target.unit + "は、" +this.tapioka.name1 + this.answer1 + this.tapioka.unit1 +  "、" +this.tapioka.name2 + this.answer2 + this.tapioka.unit2 +  "相当の" + this.target.category + "です。" + this.shareWord
       + "%20%23おもしろ単位換算メーカー%20%23タピオカ"
       + '&url=' + "https://conversion.ameneko.com/";
      location.href = shareURL
    }
  }

}
</script>

<style scoped>
.tapioka{
  margin: auto;
  max-width: 650px;
  text-align: center;
}
.target1_value{
  width: 40px;
}
.choice_result{
  padding-top:20px;
  padding-bottom:10px;
  font-weight: bold;
}
.result_card{
    margin : 10px;
    padding : 1em 1.5em ;
    line-height : 1.8 ;
    border : dotted 4px #333 ; 
    font-weight: bold;
}
.share_button{
  margin:20px;
}
.explain{
  margin-top: 100px;
}
.auther{
  margin-top: 100px;
}
.tag{
  margin:3px;
}
</style>